export enum Catalogue {
	ANWCore = 1,
	VoodooAcquisition = 2,
	VoodooProduction = 3,
	StudioSeries = 4,
	ToolsOfTheTrade = 5,
	TrailerMusic = 6,
	AudiomachineProductionDeal = 7,
	FortyFiveRPM = 8,
}

export const defaultCatalogues = [
	Catalogue.ANWCore,
	Catalogue.VoodooAcquisition,
	Catalogue.VoodooProduction,
	Catalogue.AudiomachineProductionDeal,
	Catalogue.FortyFiveRPM,
]
